import messages from './messages';

import {
  ROUTE_DISCOVER,
  ROUTE_ANALYSE_OVERVIEW,
  ROUTE_TIPS,
  ROUTE_USERS
} from './RouteList';

export const drawerItems = [
  { route: '/', label: messages.drawerHomepage, icon: 'home' },
  { route: ROUTE_DISCOVER, label: messages.drawerDiscover },
  { route: ROUTE_ANALYSE_OVERVIEW, label: messages.drawerAnalyse },
  { route: ROUTE_TIPS, label: messages.drawerTips },
  { route: ROUTE_USERS, label: messages.drawerUsers, admin: true }
];
